import styled from "styled-components";

export const PressListWrapper = styled.div`
  padding-bottom: 16rem;

  @media (max-width: 1440px) {
    padding-bottom: 8.8rem;
  }
`;
